





















































import { Component, Vue } from "vue-property-decorator";
import MonthSelectorVue from "../components/MonthSelector.vue";

import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "month-selector": MonthSelectorVue,
    },
})
export default class IncomeDistribution extends Vue {
    // 07 13 准则表格数据
    dataList = [];
    //改变时间
    period: String[] = []; // 日期
    changeDate(date: string[]) {
        this.period = date;
        this.fetchData();
    }
    // 获取表格数据
    fetchData() {
        Vue.axios
            .get(
                `incomedistribution/find?accountBookId=${this.$store.state.accountBook.id}&endPeriod=${this.period}`
            )
            .then((res) => {
                this.dataList = res.data
            });
    }
}
